import { useMemo, useState } from "react";
import { TRAFFIC_MONITORING_PROPERTIES } from "../constants";
import CameraSetting from "./CameraSetting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CAMERA_SETTING_INITIAL } from "../helpers";
import { useSensors } from "context/SensorsContext";
import { useSensorGroups } from "context/SensorGroupsContext";

function DirectionSetting(props) {
    const { sensors } = useSensors();
    const {sensorGroups} = useSensorGroups();
    const directionName = props.directionName;
    const directionIndex = props.directionIndex;
    const isEditable = props.isEditable;
    const [cameraSettings, setCameraSettings] = useState(props.cameraSettings || []);
    const [selectedCamera, setSelectedCamera] = useState({
        0: props.cameraSettings?.[0]?.cameraId || '',
        1: props.cameraSettings?.[1]?.cameraId || ''});

    const cameraList = useMemo(() => {
        if (!sensors || sensors.length === 0 || !sensorGroups || sensorGroups.length === 0 )
            return []
        const cameraGroupId = sensorGroups.find((group) => group.type === "CAMERA")?.id || null;
        return sensors.filter(sensor => sensor.groupId === cameraGroupId).map(sensor => ({
            value: sensor.id,
            label: sensor.name,
            data: sensor.data
        }));
    }, [sensors, sensorGroups]);


    const onAddCameraSetting = () => {
        if (cameraSettings.length < 2) {
            setCameraSettings(prev => ([...prev, {...CAMERA_SETTING_INITIAL}]));
        }
    };

    const onRemoveDirection = () => {
        if (props.onRemoveDirection) {
            props.onRemoveDirection(directionIndex);
        }
    };

    const onRemoveCameraSetting = (order) => {
        setCameraSettings(prev => prev.filter((_, index) => index !== order - 1));
    }

    const renderCameraSettings = () => {
        if (!cameraSettings || cameraSettings.length === 0) return null;
        if (cameraSettings.length === 1) {
            return <>
                <CameraSetting key={`cameraaddress_${directionIndex}_0`}
                    order={0}
                    cameraSetting={cameraSettings[0]}
                    directionIndex={directionIndex}
                    cameraList={cameraList.filter(cam => cam.value !== selectedCamera[1])}
                    isEditable={isEditable}
                    setSelectedCamera={setSelectedCamera}

                />
                {
                    isEditable && (
                    <button className="tmd__add-direction-btn"
                        onClick={onAddCameraSetting}
                        title='Add Camera Setting'
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                    )
                }
            </>
        }
        if (cameraSettings.length === 2) {
            return <>
                <CameraSetting key={`cameraaddress_${directionIndex}_0`}
                     order={0}
                    cameraSetting={cameraSettings[0]}
                    directionIndex={directionIndex}
                    cameraList={cameraList.filter(cam => cam.value !== selectedCamera[1])}
                    isEditable={isEditable}
                    setSelectedCamera={setSelectedCamera}
                />
                <div className='tmd__divider' />
                <CameraSetting key={`cameraaddress_${directionIndex}_1`}
                    order={1}
                    cameraSetting={cameraSettings[1]}
                    directionIndex={directionIndex}
                    cameraList={cameraList.filter(cam => cam.value !== selectedCamera[0])}
                    isEditable={isEditable}
                    onRemoveCameraSetting={onRemoveCameraSetting}
                    setSelectedCamera={setSelectedCamera}
                />
            </>;
        }
    };

    return (
        <section className="tmd__camera-direction-container">
            <div className="tmd__direction-header">
                <p className='tmd__heading'>（紐付け交通量）</p>
                {directionIndex === 1 && isEditable &&
                    <button className="tmd__direction-remove-btn" type="button"
                        onClick={onRemoveDirection} title="Direction Camera Setting">
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                }
            </div>
            
            <div className='tmd__camera-direction-name'>
                <section className="tmd__form-section">
                    <div className="tmd__label">
                        {TRAFFIC_MONITORING_PROPERTIES.TRAFFIC_DIRECTION}
                        <label className="tmd__required">*</label>
                    </div>
                    <input
                        className="tmd__input"
                        type='text'
                        defaultValue={directionName}
                        name={`directionName_${directionIndex}`}
                        disabled={!isEditable}
                    />
                </section>
            </div>
            <section className='tmd__camera-section'>
                {renderCameraSettings()}
            </section>
        </section>
    );
}

export default DirectionSetting;